module.exports = __webpack_public_path__ + "img/logo-small.0486bad2.png";